import api from './api'

export type TransitPlanetName =
  | 'Sun'
  | 'Moon'
  | 'Mars'
  | 'Mercury'
  | 'Jupiter'
  | 'Venus'
  | 'Saturn'
  | 'Rahu'
  | 'Ketu'

export interface TransitLocalized {
  planet: string
  rashi: string
  nakshatra: string
}

export interface TransitEvent {
  id: string
  planetKey: TransitPlanetName
  retrograde: boolean
  startsAt: string
  endsAt: string
  display: TransitLocalized
  english: TransitLocalized
  hindi: TransitLocalized
}

export interface TransitSearchParams {
  startDate: string
  endDate: string
  language: 'english' | 'hindi'
}

interface TransitApiEvent {
  planet_key: TransitPlanetName
  retrograde: boolean
  starts_at: string
  ends_at: string
  english: TransitLocalized
  hindi: TransitLocalized
  display: TransitLocalized
}

const DAY_MS = 24 * 60 * 60 * 1000

const formatIsoDate = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const addDays = (date: Date, days: number): Date => new Date(date.getTime() + days * DAY_MS)

export const getTransitProgress = (event: TransitEvent, now: Date = new Date()): number => {
  const start = new Date(event.startsAt).getTime()
  const end = new Date(event.endsAt).getTime()
  const current = now.getTime()

  if (end <= start) return 0
  if (current <= start) return 0
  if (current >= end) return 100

  return Math.round(((current - start) / (end - start)) * 100)
}

export const transitService = {
  getTransits: async ({ startDate, endDate, language }: TransitSearchParams): Promise<TransitEvent[]> => {
    const response = await api.get('/api/kundli/transits', {
      params: {
        start_date: startDate,
        end_date: endDate,
        language,
      },
    })

    const events: TransitApiEvent[] = response.data?.transits || []
    return events.map((event, index) => ({
      id: `${event.planet_key}-${event.starts_at}-${index}`,
      planetKey: event.planet_key,
      retrograde: event.retrograde,
      startsAt: event.starts_at,
      endsAt: event.ends_at,
      display: event.display,
      english: event.english,
      hindi: event.hindi,
    }))
  },

  getRangeForDays: (days: number): { startDate: string; endDate: string } => {
    const start = new Date()
    const end = addDays(start, days)
    return {
      startDate: formatIsoDate(start),
      endDate: formatIsoDate(end),
    }
  },
}

